import { useGlobalSettingsContext } from "contexts/GlobalSettingsContext";
import React from "react";

import ACFindingSeverityBreakDownBar, {
  FindingSeverityProps,
} from "ac-components/ACFindingSeverityBreakDownBar/ACFindingSeverityBreakDownBar";
import ACFindingSeverityRiskRating from "ac-components/ACFindingSeverityRiskRating/ACFindingSeverityRiskRating";

export default function ACFindingBreakdownWrapper({
  findingSeverity,
  activeSeverityKeys: _activeSeverityKeys,
  payload,
  clickable = true,
  redirectionFindings,
  showTrend,
  trendDayDiff,
  popupPlacement,
  data,
  TooltipComponent = undefined,
  commonFilters,
  className,
}: FindingSeverityProps) {
  const globalSettings = useGlobalSettingsContext();
  const { breakDownBySeverity } = globalSettings;

  return breakDownBySeverity ? (
    <ACFindingSeverityBreakDownBar
      {...{
        findingSeverity,
        activeSeverityKeys: _activeSeverityKeys,
        payload,
        clickable,
        redirectionFindings,
        showTrend,
        trendDayDiff,
        popupPlacement,
        data,
        TooltipComponent,
        commonFilters,
        className,
      }}
    />
  ) : (
    <ACFindingSeverityRiskRating
      {...{
        findingSeverity,
        payload,
        clickable,
        redirectionFindings,
        showTrend,
        trendDayDiff,
        popupPlacement,
        data,
        TooltipComponent,
        commonFilters,
        className,
      }}
    />
  );
}
